export class PersonalContactParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(PersonalContact.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, PersonalContact.build(item))
  }

  remove(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => PersonalContact.build(el))
    }
    return this
  }
}

export class PersonalContact {
  constructor() {
    this.id = null
    this.cellularPhone = null
    this.homePhone = null
    this.email = null
    this.personalData = null
  }

  getForAPI() {
    return {
      id: this.id,
      cellularPhone: this.cellularPhone,
      homePhone: this.homePhone,
      email: this.email,
      personalData: this.personalData,
    }
  }

  static build(obj) {
    const _this = new PersonalContact()
    if (obj) {
      _this.id = obj.id
      _this.cellularPhone = obj.cellularPhone
      _this.homePhone = obj.homePhone
      _this.email = obj.email
      _this.personalData = obj.personalData
    }
    return _this
  }
}
